<template>
    <div >
        <div class="checkbox guideline-small" v-for="(filter, key) in filterList" :key="key">
            <input type="checkbox" :value="filter" v-model="selectedOptions"  />
            <label>
                {{ filter }}
            </label>
        </div>
        <div class="d-flex gap-16 mt-24">
            <RenaultButton  is-black  @buttonclicked="closeFilter" :text="$t('store_locator.filter.cancel')" class="btn-invert"/>
            <RenaultButton  is-black  @buttonclicked="validateFilter"  :text="$t('store_locator.filter.submit')"  />
        </div>
    </div>
</template>

<script>
import RenaultButton from '../Shared/RenaultButton.vue';
export default {
    components: {
        RenaultButton,
    },
    data() {
        return {
            filterList: window.data.store_activities,
            selectedOptions: []
        };
    },
    props: {
        isReset: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        isReset(newValue) {
            newValue == true ? this.selectedOptions = [] : this.selectedOptions
        }
    },
    methods: {
        closeFilter() {
            this.$emit('closeFilter')
        },

        validateFilter() {
            this.$emit('validateFilter', this.selectedOptions)
        }
    },
};
</script>


<style lang="scss" scoped>
.checkbox {
    align-items: center;
    display: flex;
    gap: 8px;
    margin-bottom: 16px;

    input {
        height: 20px;
        margin: 0;
        width: 20px;
    }
}

.renault-button {
    width: 100%;
}

.btn-invert {
    border: 1px solid white !important;
    filter: invert(1);
}
</style>
